import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const Booking: React.FC<IconProps> = ({ size, style, color, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '20'} height={size ?? '21'} fill="none" viewBox="0 0 20 19" data-testid="booking-icon">
      <path
        d="M20 3.648C20 1.633 18.316 0 16.242 0H3.758C1.684 0 0 1.633 0 3.648v11.704C0 17.363 1.684 19 3.758 19h12.484C18.316 19 20 17.363 20 15.352Zm0 0"
        style={{
          stroke: 'none',
          fillRule: 'evenodd',
          fill: color ?? '#0c3b7c',
          fillOpacity: 1,
        }}
      />
      <path
        d="M0 11.805h9.988V19H0Zm0 0"
        style={{
          stroke: 'none',
          fillRule: 'evenodd',
          fill: color ?? '#0c3b7c',
          fillOpacity: 1,
        }}
      />
      <path
        d="m9.09 12.578-1.61-.004v-1.87c0-.4.157-.606.512-.657H9.09c.785 0 1.289.48 1.289 1.258 0 .797-.492 1.27-1.29 1.273ZM7.48 7.531V7.04c0-.434.188-.637.598-.664h.824c.707 0 1.13.41 1.13 1.098 0 .523-.29 1.136-1.102 1.136H7.48Zm3.665 1.867-.29-.16.254-.21c.297-.247.793-.805.793-1.762 0-1.47-1.172-2.414-2.988-2.414H6.61c-.535.02-.968.441-.972.968v8.328h3.32c2.016 0 3.316-1.066 3.316-2.714 0-.891-.421-1.649-1.128-2.036"
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: color ? secondaryColor || theme.palette.primary.main : '#fff',
          fillOpacity: 1,
        }}
      />
      <path
        d="M13.137 13c0-.637.531-1.152 1.18-1.152.652 0 1.183.515 1.183 1.152 0 .633-.531 1.148-1.184 1.148-.648 0-1.18-.515-1.18-1.148"
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: color ? secondaryColor || theme.palette.primary.main : '#00bafc',
          fillOpacity: 1,
        }}
      />
    </svg>
  );
};

export default Booking;
